module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-pinterest-3-a530582b2c2d49ddb9bbbb581b1338d7.jpg";